// A Home Screen icon added while the app lived at aquasensei.app still
// opens the old address; the server redirects it to tanksensei.com and
// tags the redirect with this query param. iOS only lets a Home Screen
// app ask for notifications on the address the icon was added from, so
// the app uses the tag to tell the keeper to re-add the icon instead of
// offering a Turn on button that can never work.
export const LEGACY_ICON_PARAM = 'from_old_host';
